import {
    Currency,
} from './currency';

export interface Transaction {
    amount: string;
    createdAt: string;
    currency: Currency;
    fee: Fee;
    id: string;
    processStartedAt: string;
    totalAmount: string;
    type: string;
    updatedAt: string;
    vat: Vat;
}

interface Fee {
    percentage: string;
    amount: string;
}

interface Vat {
    applyOn: string;
    baseVatAmount: string;
    countryLocation: string;
    feeVatAmount: string;
    percentage: string;
}

export enum TransactionType {
    Purchase = 'purchase',
    Withdrawal = 'withdrawal',
    FtPurchase = 'ftPurchase',
    Receive = 'receive',
    FtPurchaseGenericDisclaimer = 'ftPurchaseGenericDisclaimer',
}